import { FC } from 'react'
import { getDisplayUsername } from '@wellesley/user'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { cn, RadioGroupItem, TooltipWrapper } from '@wellesley/ui'

import { type OptionProps } from './types'

const Option: FC<OptionProps> = ({
  user,
  value,
  title,
  children,
  description,
  isDisabled,
  className,
  onChange,
}) => {
  const isMuteItem = value === 'mute'

  return (
    <label className={className}>
      <TooltipWrapper
        theme="dark"
        size="small"
        align="center"
        tooltipText={
          isDisabled
            ? `This user has already been ${isMuteItem ? 'muted' : 'blocked'}.`
            : ''
        }
        triggerClassname="w-full"
      >
        <div
          className={cn('gap-xs flex items-center', {
            'opacity-70': isDisabled,
          })}
        >
          <div
            className="gap-xxxs flex cursor-pointer flex-col items-start"
            onClick={() => !isDisabled && onChange(value)}
          >
            <h3 className="text-base font-semibold">
              {title} {getDisplayUsername(getUserNameWithDomain(user))}
            </h3>
            <p className="text-start text-sm text-gray-500">{description}</p>
          </div>
          {!isDisabled && (
            <RadioGroupItem
              id={value}
              value={value}
              data-testid={`radio-btn-${value}`}
            />
          )}
        </div>
        {children}
      </TooltipWrapper>
    </label>
  )
}

export default Option
